import React from 'react'
import { withTranslation } from 'react-i18next'
import { LocalStorageService, UserDocSuppService, UserService, AddressService } from '../../../services'
import { RequestReliableSignatureView, ReliableSignatureDescriptionView, ReliableSignaturePersonalDataView, ReliableSignatueIdentificationDocumentsView, SignRequestReliableSignatureView, ReliableSignaturePasswordGenerationView } from '../../views'
import { InformationReliable, PersonalData, Documents, PDFView, KeyCerDownload } from '../../../assets/logos/icons'
import { RegistrationValidator } from '../../../validators'

class RequestReliableSignatureAction extends React.Component {
  onBackStep = () => {
    if (this.state.selectedStep === 0) {
      this.props.history.push('/profile')
    } else {
      this.setState({
        selectedStep: this.state.selectedStep - 1
      })
    }

    return window.scroll(0, 0)
  }

  onNextStep = () => {
    this.setState({
      selectedStep: this.state.selectedStep + 1
    })

    return window.scroll(0, 0)
  }

  onHandleForm = (data, selectedStep) => {
    const {
      firstName,
      firstLastName,
      secondLastName,
      cellphoneNumber,
      phoneNumber,
      street,
      colony,
      state,
      township,
      zipCode,
      curp,
      rfc
    } = data

    this.setState({
      selectedStep: selectedStep,
      user: {
        firstName,
        firstLastName,
        secondLastName,
        cellphoneNumber,
        phoneNumber,
        curp,
        rfc,
        address: {
          street,
          colony,
          state,
          township,
          zipCode
        }
      }
    })

    return window.scroll(0, 0)
  }

  onImageChange = (event, key) => {
    if (event.target.files && event.target.files[0]) {
      let type = event.target.files[0].type.split('/')

      if (type[0] === 'image' && event.target.files[0].type !== 'image/tiff') {
        let reader = new FileReader()

        reader.onload = (e) => {
          let im = new Image()
          im.src = e.target.result
          im.onload = () => {
            this.setState({
              files: {
                ...this.state.files,
                [key]: {
                  base64: e.target.result,
                  file: event.target.files[0]
                }
              },
              [key]: e.target.result,
            })
          }
        }
        reader.readAsDataURL(event.target.files[0])
        reader = null
      } else {
        console.log('No es una imagen')
        // toggleErrorUserDocRequesting('Por favor selecciona una imagen válida para continuar (png, jpg, jpeg).')
      }
    }
  }

  onUploadFile = async (event, attr, extensions) => {
    const file = event.target.files[0]
    const result = file.name.slice(-4)

    if (extensions.includes(result)) {
      return this.setState({
        files: {
          ...this.state.files,
          [attr]: {
            file: file,
            name: file.name
          }
        }
      })
    }
  }

  onDeleteFile = async (attr) => {
    const files = Object.assign({}, this.state.files)
    delete files[attr]

    return this.setState({
      files
    })
  }

  toggleLoading = () => this.setState({
    loading: !this.state.loading
  })

  toggleErrorRequest = (value) => {
    this.setState({
      showErrorRequest: value
    }, () => {
      setTimeout(() => {
        this.setState({ showErrorRequest: false })
      }, 4000)
    })
  }

  pdfToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

  onGetFile = async () => {
    this.toggleLoadingRequesting(true)
    let messageError = this.props.t("requestReliableSignature.errors.general.save.data")

    try {
      const { ineFrontImg, ineBackImg, curpDocument, cfeDocument } = this.state.files
      let { firstName, firstLastName, secondLastName, cellphoneNumber, phoneNumber, curp, rfc } = this.state.user
      let { street, colony, state, township, zipCode } = this.state.user.address
  
      // Deleting white spaces
      firstName = (firstName) ? firstName.trim() : ''
      firstLastName = (firstLastName) ? firstLastName.trim() : ''
      secondLastName = (secondLastName) ? secondLastName.trim() : ''
      cellphoneNumber = (cellphoneNumber) ? cellphoneNumber.trim() : ''
      phoneNumber = (phoneNumber) ? phoneNumber.trim() : ''
      curp = (curp) ? curp.trim() : ''
      rfc = (rfc) ? rfc.trim() : ''
      street = (street) ? street.trim() : ''
      colony = (colony) ? colony.trim() : ''
      state = (state) ? state.trim() : ''
      township = (township) ? township.trim() : ''
      zipCode = (zipCode) ? zipCode.trim() : ''
  
      let requestFiles = new FormData()
      requestFiles.append('ineFrontImage', ineFrontImg.file)
      requestFiles.append('ineBackImage', ineBackImg.file)
      requestFiles.append('curp', curpDocument.file)
      requestFiles.append('cfe', cfeDocument.file)
  
      let userProfileInfo = new FormData()
      userProfileInfo.append('firstName', firstName)
      userProfileInfo.append('firstLastName', firstLastName)
      userProfileInfo.append('secondLastName', secondLastName)
      userProfileInfo.append('cellphoneNumber', cellphoneNumber)
      userProfileInfo.append('phoneNumber', phoneNumber)
      userProfileInfo.append('curp', curp)
      userProfileInfo.append('rfc', rfc)
  
      let userProfileAddress = new FormData()
      userProfileAddress.append('street', street)
      userProfileAddress.append('colony', colony)
      userProfileAddress.append('state', state)
      userProfileAddress.append('township', township)
      userProfileAddress.append('zipCode', zipCode)
  
      let updatedUserProfile = await this.userService.updateUserProfileInfo(userProfileInfo, this.token)
      if (updatedUserProfile.statusCode !== 200){
        messageError = this.props.t("requestReliableSignature.errors.save.profile")
        throw new Error(messageError)
      } 
  
      let updatedUserAddress = await this.userService.updatedUserProfileAddress(userProfileAddress, this.token)
      if (updatedUserAddress.statusCode !== 200){
        messageError = this.props.t("requestReliableSignature.errors.save.address")
        throw new Error(messageError)
      } 
  
      let requestReliable = await this.userDocSuppService.createRequestReliable(requestFiles, this.token)
      if (requestReliable.statusCode === 200) {
        const arr = new Uint8Array(requestReliable.data.information.dataDisclaimersPdf.data.data)
        const blob = new Blob([arr], { type: 'application/pdf' })
        const fileBase64 = await this.pdfToBase64(blob)
        const pdfBase64Request = fileBase64.split(',')[1]
  
        let localUserData = { ...this.localStorageService.getLocalStorageItem('user') }
        let updateUserData = { firstName, firstLastName, secondLastName, cellphoneNumber, phoneNumber, curp, rfc }
        localUserData.userMetaData.userA3Cloud = { ...localUserData.userMetaData.userA3Cloud, ...updateUserData }
  
        let updateAddressData = { street, colony, state, township, zipCode }
        localUserData.userMetaData.userA3Cloud.address = { ...localUserData.userMetaData.userA3Cloud.address, ...updateAddressData }
        this.localStorageService.setLocalStorageItem('user', localUserData)
        
        this.toggleLoadingRequesting(false)
        return this.setState({
          loading: false,
          requestReliablePDF: blob,
          pdfFileBase64: pdfBase64Request,
          selectedStep: this.state.selectedStep + 1,
          fileBase64: fileBase64
        })
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(messageError, 3000, false, "/")
      }      
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(messageError, 3000, false, "/")
    }
  }

  onToggleSignModal = () => this.setState({ showSignModal: !this.state.showSignModal })

  setSignatureImgeData = (signature) => {
    this.setState({
      ...signature,
      selectedStep: this.state.selectedStep + 1
    })

    return window.scroll(0, 0)
  }

  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    })
  }

  onHandleShowPassword = () => {
    let { changePasswordShowPasswordIcon } = this.state
    let inputPassword = document.querySelector('#password')

    if (changePasswordShowPasswordIcon === 'change-password-input-show-password-icon-desactive' && inputPassword.type === 'password') {
      inputPassword.type = 'text'
      this.setState({ changePasswordShowPasswordIcon: 'change-password-input-show-password-icon-active' })
    } else {
      inputPassword.type = 'password'
      this.setState({ changePasswordShowPasswordIcon: 'change-password-input-show-password-icon-desactive' })
    }
  }

  onHandleShowPasswordConfirm = () => {
    let { changePasswordShowPasswordConfirmIcon } = this.state
    let inputPassword = document.querySelector('#confirmPassword')

    if (changePasswordShowPasswordConfirmIcon === 'change-password-input-show-password-icon-desactive' && inputPassword.type === 'password') {
      inputPassword.type = 'text'
      this.setState({ changePasswordShowPasswordConfirmIcon: 'change-password-input-show-password-icon-active' })
    } else {
      inputPassword.type = 'password'
      this.setState({ changePasswordShowPasswordConfirmIcon: 'change-password-input-show-password-icon-desactive' })
    }
  }

  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: '',
    })
  }

  onGenerateKeys = async () => {
    this.toggleLoading()

    let signRequestDocumentData = new FormData()
    if (!!this.state.imgSignature) {

      signRequestDocumentData.append('imageWidth', this.state.imageWidth)
      if (this.state.pdfWidth) signRequestDocumentData.append('pdfWidth', this.state.pdfWidth)
      await fetch(this.state.imgSignature).then(res => res.blob())
        .then(blob => {
          const file = new File([blob], 'signature.png')
          signRequestDocumentData.append('sign', file, 'signature.png')
        })

      const { password, x, y, height, page, isMobile, width } = this.state

      if (x && y && width && height && page) {
        signRequestDocumentData.append('page', page)
        signRequestDocumentData.append('x', x)
        signRequestDocumentData.append('y', y)
        signRequestDocumentData.append('isMobile', false)
        signRequestDocumentData.append('width', width * 1.15)
        signRequestDocumentData.append('height', height * 1.15)
        signRequestDocumentData.append('password', password)
      }

      this.setState({ signRequestDocumentData: signRequestDocumentData })
      let generateKeysCertificate = await this.userService.createKeysCertificate(signRequestDocumentData, this.token)

      if (generateKeysCertificate.statusCode === 200) {
        let { filePrivateKey, fileCertificate, filePublicKey } = generateKeysCertificate.data

        let files = [{
          file: new Uint8Array(filePrivateKey.data.data),
          name: filePrivateKey.name
        }, {
          file: new Uint8Array(fileCertificate.data.data),
          name: fileCertificate.name
        }, {
          file: new Uint8Array(filePublicKey.data.data),
          name: filePublicKey.name
        }]

        files.forEach(item => {
          let blob = new Blob([item.file], { type: 'application/octet-binary' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = item.name
          link.click()
        })

        this.toggleLoading()
        return this.props.history.push('/profile')
      }
    }
  }

  onErrorTimeStamp = async () => {
    this.setState({ message: `${this.props.t('signatureRequestDetailAction2.errorStampTimeFails')}` })
    this.toggleErrorRequesting(true)
    return false
  }

  state = {
    imgSignature: null,
    loading: false,
    user: {},
    files: {},
    selectedStep: 0,
    changePasswordShowPasswordIcon: 'change-password-input-show-password-icon-desactive',
    changePasswordShowPasswordConfirmIcon: 'change-password-input-show-password-icon-desactive',
    ineFrontImg: '',
    ineBackImg: '',
    messageComplete: '', 
    messageError: '', 
    messageWarning: '',
    loadingRequesting: false, 
    completedRequesting: false, 
    errorRequesting: false, 
    warningRequesting: false
  }

  validations = RegistrationValidator(this.props.t)

  validator = {
    firstName: this.validations.nameValidator,
    firstLastName: this.validations.firstLastNameValidator,
    secondLastName: this.validations.secondLastNameValidator,
    curp: this.validations.curpValidator,
    rfc: this.validations.rfcValidator,
    cellphoneNumber: this.validations.cellphoneValidator,
    phoneNumber: this.validations.phoneNumberValidator,
    street: this.validations.addressValidator,
    colony: this.validations.suburbValidator,
    state: this.validations.stateValidator,
    township: this.validations.townValidator,
    zipCode: this.validations.zipCodeValidator
  }

  steps = [
    {
      icon: InformationReliable,
      title: this.props.t('requestReliableSignature.description'),
      next: this.props.t('requestReliableSignature.nextLaber'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: PersonalData,
      title: this.props.t('requestReliableSignature.personalData'),
      next: this.props.t('requestReliableSignature.nextLaber'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: Documents,
      title: this.props.t('requestReliableSignature.identificationDocuments'),
      next: this.props.t('requestReliableSignature.nextLaber'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: PDFView,
      title: this.props.t('requestReliableSignature.signRequest'),
      next: this.props.t('requestReliableSignature.signRequestView'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: KeyCerDownload,
      title: this.props.t('requestReliableSignature.passwordGeneration'),
      next: this.props.t('requestReliableSignature.downloadReliable'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
  ]

  stepMetadata = [
    { number: 0, component: ReliableSignatureDescriptionView, back: this.onBackStep, next: this.onNextStep },
    { number: 1, component: ReliableSignaturePersonalDataView, back: this.onHandleForm, next: this.onHandleForm },
    { number: 2, component: ReliableSignatueIdentificationDocumentsView, back: this.onBackStep, next: this.onGetFile },
    { number: 3, component: SignRequestReliableSignatureView, back: this.onBackStep, next: this.onNextStep },
    { number: 4, component: ReliableSignaturePasswordGenerationView, back: this.onBackStep, next: this.onGenerateKeys },
  ]

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  userDocSuppService = new UserDocSuppService(this.url)
  userService = new UserService(this.url)
  addressService = new AddressService(this.url)
  localStorageService = new LocalStorageService()

  userInfo = {}

  componentDidMount = () => {
    this.toggleLoading()
    this.token = this.localStorageService.getLocalStorageItem('token').idToken
    this.userInfo = this.localStorageService.getLocalStorageItem('user')
 
    this.getUserData()
    this.getUserDocSupps()
  }

  getUserData =  async () => {
    try {
      let userData = await this.userService.getUser(this.userInfo.userToken.sub, this.token)
        if(userData){
        let user = userData.userA3Cloud
        this.setState({
          user
        })
        
      }else{
        this.toggleLoading()
        this.toggleErrorRequesting(true)
        this.props.history.push('/profile')

      }
    } catch (error) {
      this.toggleLoading()
      this.props.history.push('/profile')
    }
  }

  getUserDocSupps = async () => {
    try {    
      let result = await this.userDocSuppService.getUserDocSupps(this.token);
      if (result) {
        let { ineFrontImg, ineBackImg } = result;

        if(ineFrontImg) {
          this.setState({
            ineFrontImg: "data:image/png;base64," + ineFrontImg,
            files: {
              ...this.state.files,
              ineFrontImg: {
                base64: "data:image/png;base64," + ineFrontImg,
                file: {}
              }
            }
          });
        }

        if(ineBackImg) {
          this.setState({
            ineBackImg: "data:image/png;base64," + ineBackImg,
            files: {
              ...this.state.files,
              ineBackImg: {
                base64: "data:image/png;base64," + ineBackImg,
                file: {}
              }
            }
          });    
        }
      }
      this.toggleLoading()
    } catch (error) {
      this.toggleLoading()
      this.toggleErrorRequesting(true)
      this.props.history.push('/profile')
    }
  };

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleErrorRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          const locationState = this.props.location.state
          if (locationState && locationState.from) {
            this.props.history.push({
              pathname: locationState.from,
              state: locationState
            })
          } else {
            this.props.history.push(sendTo)
          }
        }
      }, time || 4000)
    })
  }

  toggleCompletedRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showCompletedRequesting: true,
      messageComplete: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showCompletedRequesting: false,
        })
        if (sendInbox) {
          const locationState = this.props.location.state
          if (locationState && locationState.from) {
            this.props.history.push({
              pathname: locationState.from,
              state: locationState
            })
          } else {
            this.props.history.push(sendTo);
          }
        }
      }, time || 4000)
    })
  }

  toggleWarningRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showWarningRequesting: true,
      messageWarning: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showWarningRequesting: false,
          messageWarning: null
        })
        if (sendInbox) {
          this.props.history.push(sendTo);
        }
      }, time)
    });
  }

  render() {
    return (
      <RequestReliableSignatureView
        {...this.state}
        onImageChange={this.onImageChange}
        onUploadFile={this.onUploadFile}
        onDeleteFile={this.onDeleteFile}
        validator={this.validator}
        steps={this.steps}
        stepMetadata={this.stepMetadata}
        setImgSignature={(params) => this.setState(params)}
        setSignatureImgeData={this.setSignatureImgeData}
        onToggleSignModal={this.onToggleSignModal}
        onHandleGeneralChange={this.onHandleGeneralChange}
        onHandleShowPassword={this.onHandleShowPassword}
        onHandleShowPasswordConfirm={this.onHandleShowPasswordConfirm}
        onHandleHideError={this.onHandleHideError}
        onErrorTimeStamp={this.onErrorTimeStamp}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}      
      />
    )
  }
}

export default (withTranslation()(RequestReliableSignatureAction))
